import _SkeletonImage from "./SkeletonImage.mjs";
import { withInstall } from "../utils/index.mjs";
const SkeletonImage = withInstall(_SkeletonImage);
var stdin_default = SkeletonImage;
import { skeletonImageProps } from "./SkeletonImage.mjs";
export {
  SkeletonImage,
  stdin_default as default,
  skeletonImageProps
};
